import React from "react";
import Title from "../../ui/Title";

const EmotionalSupport = () => {
  return (
    <div id="emotional-support" className="scroll-mt-24">
      <Title
        title="The need for emotional support to caregivers"
        className="mb-6"
      />

      <div className="space-y-4 text-softBlack leading-loose text-base font-normal">
        <p>
          Caregiving is a journey filled with moments that can be both
          fulfilling and challenging. Often, the struggles caregivers face are
          hidden and they lack the support they need. Being a caregiver can also
          be highly stressful and have significant negative effects on mental
          health.
        </p>
        <p>
          <a
            href="https://www.caregiver.org/resource/caregiver-health/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue underline"
          >
            Studies reviewed
          </a>{" "}
          by the Family Caregiver Alliance suggest that there are higher levels
          of depression and other mental health issues among caregivers as
          compared to non-caregivers.
        </p>
        <p>
          During the research the Caregiving Lab conducted in India and Nepal,
          we found that caregivers often undergo tremendous stress, causing
          adverse effects on their mental health and well-being, and manifesting
          as depressive symptoms, anxiety, sleeplessness, and loss of appetite.
          The uncertainties while taking care of someone, financial challenges,
          the stress of making decisions, and changes in family dynamics often
          leave caregivers emotionally drained.
        </p>
        <p>
          We also found that most caregivers tend to lose themselves in care,
          with their own emotional and health needs often going unaddressed.
          They find it difficult to express how they feel to family members and
          are often unaware of, or have limited access to, resources for
          emotional support.
        </p>
        <p>
          In order to provide effective support to caregivers, it is imperative
          that support systems developed for them also focus on mental
          healthcare. While the need is apparent, there are many societal
          barriers that prevent people from accessing or receiving the mental
          health support they need.
        </p>
        <p className="font-bold !mt-6">
          Some of the major barriers to mental health support include:
        </p>
        <ul className="space-y-2 list-disc list-outside ml-6">
          <li>Limited understanding of mental health</li>
          <li>Stigma around discussing mental health and seeking support</li>
          <li>
            Lack of accessibility to mental health services due to financial
            constraints, lack of adequate services, infrastructure, human
            resources
          </li>
        </ul>
      </div>
    </div>
  );
};

export default EmotionalSupport;
